var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecruit2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6239 72.4591L51.0936 58.2357C52.5492 56.9278 53.693 55.8243 54.5248 54.9251C55.3566 54.0259 56.0012 53.1165 56.4587 52.1969C56.9162 51.2568 57.145 50.2452 57.145 49.1621C57.145 47.9564 56.8538 46.904 56.2716 46.0048C55.7101 45.0851 54.9303 44.3903 53.9321 43.9203C52.9339 43.4298 51.8006 43.1744 50.5321 43.154C48.5774 43.1744 47.0073 43.7568 45.822 44.9012C44.6575 46.0456 44.0856 47.609 44.1064 49.5913H34C34 46.6485 34.6862 44.0736 36.0587 41.8665C37.4312 39.6594 39.3651 37.9632 41.8606 36.7779C44.3768 35.5926 47.2881 35 50.5945 35C53.9425 35 56.885 35.562 59.422 36.686C61.959 37.8099 63.9242 39.3835 65.3174 41.4067C66.7315 43.4094 67.4385 45.7289 67.4385 48.3651C67.4177 50.1226 67.0434 51.8188 66.3156 53.4537C65.6086 55.0886 64.3713 56.9074 62.6037 58.9101C60.8361 60.9128 58.3303 63.3038 55.0862 66.0831L49.4092 71.233V71.5395H68V80H34.6239V72.4591Z",
    fill: "#FEBC18"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruit2);
export default __webpack_public_path__ + "static/media/recruit_2.b1d9ae989cb791fe936d92145b56c975.svg";
export { ForwardRef as ReactComponent };